"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var React = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _is = require("@utiljs/is");
var _Iconfont = _interopRequireWildcard(require("./Iconfont"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// 大小以及颜色样式
function sizeAndColor(props) {
  var size = props.size,
    style = props.style,
    color = props.color,
    rotate = props.rotate;
  var styles = {};
  if (size) {
    var realSize = typeof size === 'number' ? "".concat(size, "px") : size;
    styles = {
      height: realSize,
      width: realSize,
      fontSize: realSize
    };
  }
  if (color) {
    styles.color = color;
  }
  if (rotate) {
    styles.transform = "rotate(".concat(rotate, "deg)");
  }
  return (0, _assign.default)((0, _assign.default)({}, styles), style);
}
// icon图标样式
function iconClassName(props) {
  if (typeof props.name !== 'string') {
    // 用户自定义svg组件等
    return (0, _classnames.default)('roo-icon', props.className, {
      'ani-custom-spin': props.spin
    });
  }
  if ((0, _Iconfont.isCustomIconfont)(props.name)) {
    return (0, _classnames.default)('roo-icon', 'roo-iconfont', props.className, {
      'ani-custom-spin': props.spin
    });
  }
  var nameClass = props.name === 'loading' || props.spin ? "roo-icon-".concat(props.name, " ani-spin") : "roo-icon-".concat(props.name);
  return (0, _classnames.default)('roo-icon', nameClass, props.className);
}
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor'
};
var Icon = function Icon(props) {
  var children = props.children,
    size = props.size,
    name = props.name,
    color = props.color,
    otherProps = __rest(props, ["children", "size", "name", "color"]);
  var iconfontIcon = null;
  if ((0, _Iconfont.isCustomIconfont)(name)) {
    iconfontIcon = /*#__PURE__*/React.createElement("svg", (0, _assign.default)({}, svgBaseProps), /*#__PURE__*/React.createElement("use", {
      xlinkHref: "#".concat(name)
    }));
  }
  return /*#__PURE__*/React.createElement("i", (0, _assign.default)({}, otherProps, {
    className: iconClassName(props),
    style: sizeAndColor(props)
  }), (0, _is.isFunction)(name) ? /*#__PURE__*/React.createElement(name) : iconfontIcon, children);
};
Icon.defaultProps = {
  size: undefined,
  color: undefined,
  className: undefined,
  style: undefined
};
Icon.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
Icon.extend = _Iconfont.default;
var _default = exports.default = Icon;